import React from "react";
import Header from "./Header";
import "../css/seo.css";
import Footer from "./Footer";
function SEO() {
  return (
    <div className="maindd">
      <Header></Header>
      <div className="section0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Search Engine Optimization – SEO Company</h4>
              <p>Invest in Your Future with an SEO Company that Gets Results</p>
              <a href="/#" className="btn btn-outline-primary">
                GET MY FREE PROPOSAL{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="section000">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p>
                <b>An SEO Marketing Company That Gets It</b> <br />
                Let’s face it. You know what you need but you just don’t know
                how to get it. Our SEO specialists hear that over and over from
                SEO clients who contact Thrive Internet Marketing Agency.
                <br />
                You’re likely here because of one or more of the following
                reasons:
                <br />
                • Your website isn’t being found online. <br />
                • Your website traffic has diminished recently and you don’t
                know why. <br />
                • Suddenly, your volume of incoming calls and leads has
                declined. <br />• You’re starting a new website and want to ramp
                up new business quickly.
              </p>
              <br />
            </div>
            <div className="col-md-6">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4O6VYWZwD-0DzDLUpwi6tqEwvw1QIxCTT0g&usqp=CAU"
                alt=""
              />
            </div>
            <div className="col-12">
              If any of these four pain points ring a bell, rest assured, you’ve
              come to the right SEO company. There’s a reason why Thrive is
              <b>currently </b>serving hundreds of SEO clients and providing
              optimization solutions to answer Google’s ever-changing algorithm.
            </div>
          </div>
        </div>
      </div>
      <div className="section4">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9aCMeX2cx-RFDbk_zNnKZR-lFxvQ_aF4xHA&usqp=CAU"
                  alt=""
                />
                <div className="co">
                  <h6>
                    <a href="/#">CONSTRUCTION COMPANY</a>
                  </h6>
                </div>
                <div className="row">
                  <div className="col-6">
                    <p>
                      <span> +800%</span>
                      <br />
                      Online Leads
                    </p>
                  </div>
                  <div className="col-6">
                    <p>
                      <span> +800%</span>
                      <br />
                      Online Leads
                    </p>
                  </div>
                </div>
                <p>
                  Thrive has gone above and beyond and it’s allowed me to focus
                  on other aspects of business development. Thrive understands
                  the intricate needs of what we want to accomplish.”
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9aCMeX2cx-RFDbk_zNnKZR-lFxvQ_aF4xHA&usqp=CAU"
                  alt=""
                />
                <div className="co">
                  <h6>
                    <a href="/#">CONSTRUCTION COMPANY</a>
                  </h6>
                </div>
                <div className="row">
                  <div className="col-6">
                    <p>
                      <span> +800%</span>
                      <br />
                      Online Leads
                    </p>
                  </div>
                  <div className="col-6">
                    <p>
                      <span> +800%</span>
                      <br />
                      Online Leads
                    </p>
                  </div>
                </div>
                <p>
                  Thrive has gone above and beyond and it’s allowed me to focus
                  on other aspects of business development. Thrive understands
                  the intricate needs of what we want to accomplish.”
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="box">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9aCMeX2cx-RFDbk_zNnKZR-lFxvQ_aF4xHA&usqp=CAU"
                  alt=""
                />
                <div className="co">
                  <h6>
                    <a href="/#">CONSTRUCTION COMPANY</a>
                  </h6>
                </div>
                <div className="row">
                  <div className="col-6">
                    <p>
                      <span> +800%</span>
                      <br />
                      Online Leads
                    </p>
                  </div>
                  <div className="col-6">
                    <p>
                      <span> +800%</span>
                      <br />
                      Online Leads
                    </p>
                  </div>
                </div>
                <p>
                  Thrive has gone above and beyond and it’s allowed me to focus
                  on other aspects of business development. Thrive understands
                  the intricate needs of what we want to accomplish.”
                </p>
              </div>
            </div>
            <div className="col-12">
              <p>
                Our digital marketing agency follows a systematic approach to
                ensure all our online marketing efforts deliver profitable
                results. Leverage Thrive’s internet marketing services today and
                let us help you boost your customer acquisition and retention
                rates.
              </p>
              <img
                src="https://thriveagency.com/files/awardimage2022-1-1-1-1536x204.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="section5 section555 holy">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Our SEO Services</h4>
              <p className="p">
                Increase Your Search Rankings and Get Discovered More Online{" "}
              </p>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section666">
        <div className="container">
          <div className="row">
            <div className="col-9">
              <img src="https://thriveagency.com/files/Group-1877.png" alt="" />
            </div>
            <div className="col-12">
              <a href="/#" className="btn btn-outline-success">
                CONTACT US TO OUR OUTRANK YOUR COMPETITORS
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="section5 section555 holy">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Our SEO Services</h4>
              <p className="p">
                Increase Your Search Rankings and Get Discovered More Online{" "}
              </p>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <div className="row">
                <div className="col-3">
                  <i class="fa-solid fa-laptop"></i>
                </div>
                <div className="col-9">
                  <p className="pp">Keyword Research & Strategy</p>
                </div>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section777">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>
                Get Your FREE Instant <span> SEO Audit Report Now!</span>
              </h1>
            </div>
            <div className="col-md-6 form">
              <p>Free Instant SEO Audit Report</p>
              <form>
                <div class="mb-3">
                  <input
                    type="email"
                    placeholder="Enter Name"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div class="mb-3">
                  <input
                    type="email"
                    placeholder="Enter LastName"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div class="mb-3">
                  <input
                    type="email"
                    placeholder="Enter Website"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div class="mb-3">
                  <input
                    type="password"
                    placeholder="Your E-mail"
                    class="form-control"
                    id="exampleInputPassword1"
                  />
                </div>

                <button type="submit" class="btn btn-success">
                  Get Free Report Now
                </button>
              </form>
            </div>
            <div className="col-md-6">
              <img
                src="https://media.sketchfab.com/models/a678a9a4270541c8a57e2e7c4d1f775f/thumbnails/60e9c342786a4f02bae09109354fa1e4/fd09e7564db644fd8ad1cc3dfc0ca8c6.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="section888">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Thrive’s Agile SEO Methodology</h1>
              <p className="p">Your First Step Towards Digital Success</p>
              <p>
                The search landscape is constantly evolving. To rank high on
                search engines, you need to invest in the right SEO services
                tailored to your business’ needs, demands and target customers.
                Simply relying on old SEO tactics is not enough to maintain a
                robust online presence -- you need to find a reliable SEO
                company that can take your digital marketing efforts up a notch.
                <br />
                Thrive Internet Marketing Agency is a customer-focused SEO
                company. Our SEO experts work closely with our clients to
                develop personalized SEO strategies that drive long-term
                profitability. By using a proven, efficient and effective
                methodology, we are able to create high-quality, measurable
                results.
                <br />
                Our SEO company utilizes a methodology called “Agile SEO,” which
                allows us to build a robust campaign framework that provides
                value for your business. Thrive’s Agile SEO approach is built
                around the following processes:
              </p>
            </div>
            <div className="col-12 img">
              <br />{" "}
              <img
                src="https://thriveagency.com/files/pasted-image-0-14.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section5 section555 holy section5555">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your websitelg- col-md-6 mt-5and the competitive landscape.
              </p>
            </div>

            <div className="col-md-6">
              <i class="fa-solid fa-laptop"></i>
              <p className="pp">Keyword Research & Strategy</p>
              <p>
                Thrive is an SEO agency that understands your niche and can
                boost your ranking for specific search terms. Your dedicated SEO
                specialist will review the keywords your website is currently
                ranking for, take your keyword wishlist and conduct additional
                keyword research to build a list that makes the most sense for
                your website and the competitive landscape.
              </p>
              lg- col-md-6 mt-5{" "}
            </div>

            <div className="col-6 mid">
              <div className="box">
                <i class="fa-solid fa-laptop"></i>
                <p className="pp">Keyword Research & Strategy</p>
                <p>
                  Thrive is an SEO agency that understands your niche and can
                  boost your ranking for specific search terms. Your dedicated
                  SEO specialist will review the keywords your website is
                  currently ranking for, take your keyword wishlist and conduct
                  additional keyword research to build a list that makes the
                  most sense for your website and the competitive landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section3">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>Why Search Engine Optimization is a Great Investment</h4>
              <p>We Practice What We Preach to Provide Maximum ROI</p>
            </div>

            <div className="col-md-6">
              <p>
                All business owners want more bang for their buck. All want
                better profit margins. SEO saves you money. Consider SEO as an
                employee: SEO never clocks out. SEO never calls in sick. SEO
                never takes a holiday. SEO works for you around the clock, even
                when you’re sleeping.
                <br />
                No, SEO won’t answer the phone. But it will keep the phone
                ringing. SEO done right will funnel customers to your website
                and put them in front of your products, services and brand.
                <br />
                We’ve spent years refining our SEO strategy. What we do not only
                works for our clients, but it also works for our website.
                <br />{" "}
              </p>
              <br />{" "}
            </div>
            <div className="col-md-6">
              <img src="https://thriveagency.com/files/Group-2045.png" alt="" />
            </div>
            <div className="col-12">
              <p>
                We live by what we sell. Since 2016, Thrive has experienced
                exponential growth, landing on the Inc. 5000 list among
                America’s fastest-growing private companies for seven
                consecutive years.
                <br />
                We get the most out of our organic search results. We believe in
                SEO so much that we rely on it. It’s the lifeblood of our
                business.
                <br />
                And let this sink in: You likely wouldn’t be here without SEO.
                How did you find this page? With a Google search? If so, you’re
                an example of SEO working for us. Now, put it to work for your
                business.
              </p>
              <br />{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="comman commann holly">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <a href="/#" className="btn btn-outline-success">
                GROW MY LEADS NOW
              </a>
              <p className="pp">
                <b>Search Engine Optimization FAQs</b>
              </p>
            </div>
            <div className="col-12">
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Accordion Item #1
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    class="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <strong>This is the first item's accordion body.</strong>{" "}
                      It is shown by default, until the collapse plugin adds the
                      appropriate classes that we use to style each element.
                      These classes control the overall appearance, as well as
                      the showing and hiding via CSS transitions. You can modify
                      any of this with custom CSS or overriding our default
                      variables. It's also worth noting that just about any HTML
                      can go within the <code>.accordion-body</code>, though the
                      transition does limit overflow.
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingTwo">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Accordion Item #2
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <strong>This is the second item's accordion body.</strong>{" "}
                      It is hidden by default, until the collapse plugin adds
                      the appropriate classes that we use to style each element.
                      These classes control the overall appearance, as well as
                      the showing and hiding via CSS transitions. You can modify
                      any of this with custom CSS or overriding our default
                      variables. It's also worth noting that just about any HTML
                      can go within the <code>.accordion-body</code>, though the
                      transition does limit overflow.
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingThree">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Accordion Item #3
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <strong>This is the third item's accordion body.</strong>{" "}
                      It is hidden by default, until the collapse plugin adds
                      the appropriate classes that we use to style each element.
                      These classes control the overall appearance, as well as
                      the showing and hiding via CSS transitions. You can modify
                      any of this with custom CSS or overriding our default
                      variables. It's also worth noting that just about any HTML
                      can go within the <code>.accordion-body</code>, though the
                      transition does limit overflow.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default SEO;
